module.exports = __webpack_public_path__ + "img/icon_account_blue.e09b4cb3.svg";